type Child = JSX.Element | string | null;

type Props = {
  children: Child[] | Child;
};

const Paragraph = ({ children }: Props) => {
  return (
    <p className="flex-grow-1 to-black text-left text-base leading-normal">
      {children}
    </p>
  );
};

export default Paragraph;
